import app from 'flarum/forum/app';

// Alle 5 Minuten still pruefen, ob sich die Gruppen des angemeldeten Benutzers geaendert haben
// (der Server gleicht sie dabei mit dem AD ab). Nur bei einer Aenderung werden Abzeichen und
// Rechte nachgeladen – ohne Seitenwechsel, damit z. B. ein angefangener Beitrag erhalten bleibt.
const INTERVAL = 5 * 60 * 1000;
function groupKey(user) {
  return (user.groups() || []).filter(Boolean).map(group => group.id()).sort().join(',');
}
function refreshGroups() {
  const user = app.session.user;
  if (!user) return;
  const before = groupKey(user);
  app.store.find('users', user.id()).then(() => {
    if (groupKey(user) === before) return;

    // Forum-Rechte (z. B. Diskussion starten) und Tag-Rechte neu laden.
    return app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl')
    }).then(payload => {
      app.store.pushPayload(payload);
      return app.store.find('tags').catch(() => null);
    }).then(() => m.redraw());
  }).catch(error => {
    console.warn('[AD-Groups] Gruppen konnten nicht aktualisiert werden:', error);
  });
}
app.initializers.add('talentschmiede-ad-groups', () => {
  window.setInterval(refreshGroups, INTERVAL);
});